export default __webpack_public_path__ + "static/media/Asset1_lrg.5792a9b3.png";